import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TextInput } from '../..';

export const NumberMinValueValidator: () => ValidatorFn = () => {
    return (control: AbstractControl): ValidationErrors | null => {
        const internalControl = control as TextInput;
        if (internalControl.value && internalControl.min) {
            const num = parseFloat(internalControl.value);
            if (num < internalControl?.min) {
                return { number_before_min: true };
            } else {
                return null;
            }
        }
        return null;
    };
};
